import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { toast } from "react-toastify";
import { Table, Button, Container, Divider, Grid, Confirm, Dimmer, Loader, Label, Input, Modal, Header, Icon, Tab, TabPane, Dropdown, Form } from 'semantic-ui-react'
import FuseInputModal from '../../../components/generic/FuseInputModal';
import PlaceholderSegment from '../../../components/generic/PlaceholderSegment';
import * as GLOBAL_LOOKUP_ACTIONS from '../../../actions/globalLookupsActions';
import { AVAILABLE_TRANSLATION_LANGUAGES, getTranslationRequestLanguages, TRANSLATION_MODES } from '../../../constants/translations';

const availableLanguages = AVAILABLE_TRANSLATION_LANGUAGES;

export function GlobalLookupsPage(props) {
    const [state, setState] = useState({
        openLookupValuesModal: false,
        lookupSearchQuery: "",
        isEditLookupOpen: false,
        isEditValueOpen: false,
        selectedLookup: {},
        lookupValues: [],
        selectedValue: {},
        showConfirmDelete: false,
        deleteCandidate: {},

        selectedLookupValueLanguage:'',
        isEditLookupValueTranslationOpen: false,
        selectedTranslationItem: null,
        selectedTranslationIndex: null,
        isEditLookupNameTranslationOpen: false,
        selectedLookupNameLanguage: '',
        showConfirmTranslate: false,
        translationMode: TRANSLATION_MODES.ADDITIVE
    });

    const hasPermissions = (category) => {
        return !_.isEmpty(props.userPermissions) && props.userPermissions.hasOwnProperty(category)
    }

    const isAdmin = () => {
        return hasPermissions('Other') && props.userPermissions['Other'].actions.admin
    }

    const canReadLookup = () => {
        return hasPermissions('Questionnaire Lookup Values') && props.userPermissions['Questionnaire Lookup Values'].actions.READ || isAdmin()
    }

    const canCreateLookup = () => {
        return hasPermissions('Questionnaire Lookup Values') && canReadLookup() && props.userPermissions['Questionnaire Lookup Values'].actions.CREATE || isAdmin()
    }

    const canUpdateLookup = () => {
        return hasPermissions('Questionnaire Lookup Values') && canReadLookup() && props.userPermissions['Questionnaire Lookup Values'].actions.UPDATE || isAdmin()
    }

    const canDeleteLookup = () => {
        return hasPermissions('Questionnaire Lookup Values') && canReadLookup() && props.userPermissions['Questionnaire Lookup Values'].actions.DELETE || isAdmin()
    }

    useEffect(() => {
        if (!_.isEmpty(props.tenant)) {
            if (props.isPermissionsFetched) {
                if (canReadLookup()) {
                    props.fetchGlobalLookupsAction(props.tenant);
                } else {
                    toast.error('You do not have permission to view lookup values');
                }
            }
        }
    }, [props.tenant]);

    const openLookupNameTranslationEdit = (language) => {
        setState(prevState => ({
            ...prevState,
            isEditLookupNameTranslationOpen: true,
            selectedLookupNameLanguage: language
        }));
    };

    const updateLookupNameTranslation = (languageCode, newTranslation) => {
        const updatedLookup = { ...state.selectedLookup };
        if (!updatedLookup.translations) {
            updatedLookup.translations = {};
        }
        if (!updatedLookup.translations.name) {
            updatedLookup.translations.name = {};
        }
        updatedLookup.translations.name[languageCode] = newTranslation;
        props.saveGlobalLookupsAction(updatedLookup, props.tenant.id);
        
        setState(prevState => ({
            ...prevState,
            selectedLookup: updatedLookup,
            selectedLookupNameLanguage: ''
        }));
    };

    const lookupNameTranslationEdit = () => {
        if (!state.isEditLookupNameTranslationOpen) {
            return null;
        }
        const currentTranslation = state.selectedLookup?.translations?.name?.[state.selectedLookupNameLanguage] || '';
        const originalName = state.selectedLookup?.name || '';
        // Find the language object to get the display name
        const languageObj = availableLanguages.find(lang => lang.value === state.selectedLookupNameLanguage);
        const languageName = languageObj ? languageObj.text : state.selectedLookupNameLanguage;

        return (
            <FuseInputModal
                label={`${languageName} translation for "${originalName}":`}
                initialValue={currentTranslation}
                onOk={(valueChanged, returnValue) => {
                    setState(prevState => ({ ...prevState, isEditLookupNameTranslationOpen: false }));
                    
                    if (valueChanged) {
                        updateLookupNameTranslation(state.selectedLookupNameLanguage, returnValue);
                    }
                }}
                onCancel={() => {
                    setState(prevState => ({
                        ...prevState,
                        isEditLookupNameTranslationOpen: false,
                        selectedLookupNameLanguage: ''
                    }));
                }}
            />
        );
    };

    const handleLookupValueLanguageChange = (e, { value }) => {
        setState(prevState => ({ ...prevState, selectedLookupValueLanguage: value }));
    };

    const openLookupValueTranslationEdit = (item, index) => {
        setState(prevState => ({
            ...prevState,
            isEditLookupValueTranslationOpen: true,
            selectedTranslationItem: item,
            selectedTranslationIndex: index
        }));
    };

    const renderLookupValuesTranslaitons = () => {
        if (!state.selectedLookupValueLanguage || !state.selectedLookup?.translations?.values) {
            return (
                <Table.Row>
                    <Table.Cell colSpan='2' textAlign='center'>
                        Please select a language to view translations.
                    </Table.Cell>
                </Table.Row>
            );
        }
        return state.selectedLookup.translations.values.map((item, index) => {
            const translatedValue = item.translations[state.selectedLookupValueLanguage] || item.original;
            return (
                <Table.Row key={`${item.original}-${index}`}>
                    <Table.Cell>{item.original}</Table.Cell>
                    <Table.Cell>{translatedValue}</Table.Cell>
                    <Table.Cell textAlign='right'>
                        <Button compact className="warning" icon='edit' size='mini'
                        onClick={() => openLookupValueTranslationEdit(item, index)}/>
                    </Table.Cell>
                </Table.Row>
            );
        });
    };

    //TODO: Come back
    const onLookupSelectionChanged = (rowId) => {
        if (rowId !== 'new') {
            const lookups = props.lookups.filter(x => x.id === rowId);
            if (lookups.length > 0) {
                const lookup = lookups[0];
                setState((state) => ({
                    ...state,
                    selectedLookup: lookup,
                    lookupValues: valueObjectsFromString(lookup.values)
                }));
            }
            else {
                setState((state) => ({
                    ...state,
                    selectedLookup: {},
                    lookupValues: []
                }));
            }
        }
        else {
            setState((state) => ({
                ...state,
                selectedLookup: {
                    id: 0,
                    keyName: ''
                },
                lookupValues: []
            }));
        }
    }

    const onEditLookupRow = (rowId) => {
        onLookupSelectionChanged(rowId)
        setState((state) => ({ ...state, isEditLookupOpen: true }));
    }


    const onValueSelectionChanged = (valueId) => {
        if (valueId !== 'new') {
            const values = state.lookupValues;
            const value = values[valueId];
            setState((state) => ({
                ...state,
                selectedValue: {
                    id: valueId,
                    value: value.value,
                }
            }));
        }
        else {
            setState((state) => ({
                ...state,
                selectedValue: {
                    id: valueId,
                    value: ''
                }
            }));
        }
    }

    const onEditValueRow = (rowId) => {
        onValueSelectionChanged(rowId)
        setState((state) => ({ ...state, isEditValueOpen: true }));

    }

    const confirmEditLookUpValue = (rowId) => {
        let contentMessage = "The questionnaire is currently active or under review. Editing any part of the questionnaire will result in its deactivation, requiring it to undergo the review process again.";

        return (
            <Confirm
                header='Warning:'
                content={contentMessage}
                open={state.showConfirmEditLookUpValue}
                onCancel={() => setState((state) => ({ ...state, showConfirmEditLookUpValue: false }))}
                onConfirm={() => {
                    setState((state) => ({ ...state, isEditValueOpen: true, showConfirmEditLookUpValue: false, deactiveQnaire: true }));
                }}
            />
        );
    }



    const valueObjectsFromString = (json) => {
        if (!_.isEmpty(json)) {
            return JSON.parse(json);
        }
        else {
            return [];
        }
    }

    const valueObjectsToString = (valueObjectArray) => {
        return JSON.stringify(valueObjectArray);
    }


    const updateValuesToLookup = (values) => {
        var toCommit = state.selectedLookup;
        //Note that the intention here is not to update the old state, we just use it have an object to send to our action creator. State objects should only ever be modified using setState and not directly...
        toCommit.values = valueObjectsToString(values);
        props.saveGlobalLookupsAction(toCommit, props.tenant.id);
        setState((state) => ({ ...state, lookupValues: state.newlookupValues }));
    }


    const confirmDelete = () => {
        return (
            <Confirm
                content={`Are you sure you want to delete the following lookup with all its values: ${state.deleteCandidate.name}?`}
                open={state.showConfirmDelete}
                onCancel={() => setState((state) => ({ ...state, showConfirmDelete: false }))}
                onConfirm={() => {
                    var deleteGlobalLookup = state.deleteCandidate;
                    props.deleteGlobalLookup(deleteGlobalLookup);
                    onLookupSelectionChanged(0);
                    setState((state) => ({ ...state, showConfirmDelete: false }));
                }
                }
            />
        );
    }

    const confirmTranslate = () =>{
        const concernedLanguages = getTranslationRequestLanguages(state.selectedLookup);

        return(
            <Modal
                open={state.showConfirmTranslate}
                onClose={() => setState((currentState) => ({ ...currentState, showConfirmTranslate: false }))}
                size='small'
            >
                <Modal.Header>Translate lookup</Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Radio
                            label='Add missing translations (recommended)'
                            checked={state.translationMode === TRANSLATION_MODES.ADDITIVE}
                            onChange={() => setState((currentState) => ({
                                ...currentState,
                                translationMode: TRANSLATION_MODES.ADDITIVE
                            }))}
                        />
                        <p>Adds translations only where a value is missing or blank. Existing translations, including manual edits, are preserved.</p>
                        <Form.Radio
                            label='Re-translate all content'
                            checked={state.translationMode === TRANSLATION_MODES.RETRANSLATE}
                            onChange={() => setState((currentState) => ({
                                ...currentState,
                                translationMode: TRANSLATION_MODES.RETRANSLATE
                            }))}
                        />
                        <p>Generates new translations for all content in every configured language. Existing translations, including manual edits, will be overwritten.</p>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setState((currentState) => ({ ...currentState, showConfirmTranslate: false }))}>
                        Cancel
                    </Button>
                    <Button
                        negative={state.translationMode === TRANSLATION_MODES.RETRANSLATE}
                        primary={state.translationMode === TRANSLATION_MODES.ADDITIVE}
                        disabled={concernedLanguages.length === 0 || state.selectedLookup.status === 'translating'}
                        onClick={async () => {
                            const lookupBeforeTranslation = state.selectedLookup;
                            setState((currentState) => ({
                                ...currentState,
                                selectedLookup: {
                                    ...currentState.selectedLookup,
                                    status: 'translating'
                                }
                            }));

                            try {
                                await props.translateLookup(lookupBeforeTranslation, props.tenant.id, state.translationMode)
                                setState((currentState) => ({
                                    ...currentState,
                                    showConfirmTranslate: false
                                }))
                            } catch (error) {
                                // The action displays the request failure and leaves the modal open.
                                setState((currentState) => ({
                                    ...currentState,
                                    selectedLookup: currentState.selectedLookup.id === lookupBeforeTranslation.id
                                        ? lookupBeforeTranslation
                                        : currentState.selectedLookup
                                }));
                            }
                        }}
                    >
                        Start translation
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }

    const LookupItems = () => {

        const isRootTenant = props.tenant.isRoot === true || false;

        const lower = state.lookupSearchQuery.toLowerCase();
        const filteredLookups = useMemo(() => {
            return props.lookups.filter(row =>
            String(row.name).toLowerCase().includes(lower)
        );
        }, [props.lookups, state.lookupSearchQuery]);


        if (!props.fetchingData) {
            if (!_.isEmpty(filteredLookups)) {
                filteredLookups.sort((a, b) => a.name.localeCompare(b.name));
                return (
                    <Table compact selectable size='small'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='nectaPrimaryBg'>Lookup Name</Table.HeaderCell>
                                <Table.HeaderCell className='nectaPrimaryBg' />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {filteredLookups.map(lookup => {
                                return (
                                    <Table.Row key={lookup.id} className='clickable' onClick={() => {onLookupSelectionChanged(lookup.id);setState(prevState=>({...prevState,openLookupValuesModal:true}))
                                    }} active={lookup.id === state.selectedLookup.id}>
                                        <Table.Cell>{lookup.name}</Table.Cell>
                                        <Table.Cell textAlign='right'>
                                            {(lookup.status === 'translation_successful')&&(
                                                <Button compact color='green' size ='mini' style={{marginRight:'8px'}}>
                                                    Translated
                                                </Button>
                                            )}
                                            {(canUpdateLookup() || ((isRootTenant))) && (lookup.status !=='translating')&& (
                                                <Button compact className='warning' icon='edit' size='mini' onClick={(e) => { e.stopPropagation(); onEditLookupRow(lookup.id) }} />
                                            )}
                                            {(canDeleteLookup() || ((isRootTenant))) && (lookup.status !=='translating') && (
                                                <Button compact className='danger' icon='trash' size='mini' onClick={(e) => {
                                                     e.stopPropagation();
                                                    setState((state) => ({ ...state, deleteCandidate: lookup, showConfirmDelete: true }));

                                                }} />
                                            )}
                                            {(lookup.status ==='translating')&&(lookup.id!==state.selectedLookup.id)&&(
                                                <Label color='yellow' size='mini'>
                                                    Translating...
                                                </Label>
                                            )}                                            
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })
                            }
                        </Table.Body>
                    </Table>
                );
            }
            else if(!_.isEmpty(props.lookups)&&(_.isEmpty(filteredLookups))) {
                return (
                    <PlaceholderSegment text="No results match your search." />
                );
            }
            else{
                return (
                    <PlaceholderSegment text="There are no lookup items yet," />
                );
            }
        }
        else {
            return (
                <div style={{ height: "200px", margin: "10px 0px" }}>
                    <Dimmer inverted active>
                        <Loader content='Loading' />
                    </Dimmer>
                </div>
            );
        }
    }

    const lookupValues = () => {
        const isRootTenant = props.tenant.isRoot === true || false;

        return state.lookupValues
            .map((lookupValue, index) =>
                <Table.Row key={`${lookupValue.id}.${index}`}>
                    <Table.Cell>{lookupValue.value}</Table.Cell>
                    <Table.Cell  textAlign='right'>
                        {(canUpdateLookup() || ((isRootTenant))) && (
                            <Button compact className="warning" icon='edit' size='mini' 
                            disabled={state.selectedLookup.status === 'translating'} onClick={(e) => { e.stopPropagation(); onEditValueRow(index); }} />
                        )}
                        {(canDeleteLookup() || ((isRootTenant))) && (
                            <Button compact className='danger' icon='trash' size='mini' 
                            disabled={state.selectedLookup.status === 'translating'} onClick={(e) => {
                                e.stopPropagation();
                                var newstate = [...state.lookupValues];
                                var itemIndex = newstate.indexOf(newstate[index]);

                                if (itemIndex > -1) {
                                    newstate.splice(itemIndex, 1);
                                }

                                setState((state) => ({ ...state, newlookupValues: newstate }));

                                updateValuesToLookup(newstate)
                                onValueSelectionChanged(0)
                            }} />
                        )}
                    </Table.Cell>
                </Table.Row>
            );
    }

    const lookupEdit = () => {
        if (state.isEditLookupOpen) {
            return (
                <FuseInputModal
                    label='Lookup Name:'
                    initialValue={state.selectedLookup.name}
                    onOk={(valueChanged, returnValue) => {
                        setState((state) => ({ ...state, isEditLookupOpen: false }));

                        if (valueChanged === true) {
                            if (state.selectedLookup.id === 0) {
                                let toCommit = _.omit({ ...state.selectedLookup }, ['id'])
                                toCommit.name = returnValue;
                                // toCommit.status = 'active' //TODO: Come back here
                                props.saveGlobalLookupsAction(toCommit, props.tenant.id);
                            } else {
                                let toUpdate = state.selectedLookup
                                toUpdate.name = returnValue
                                props.saveGlobalLookupsAction(toUpdate, props.tenant.id);
                            }
                        }
                    }
                    }
                    onCancel={() => {
                        setState((state) => ({
                            ...state,
                            isEditLookupOpen: false
                        }));
                    }}
                />
            )
        }
    }

    const updateTranslation = (itemIndex, newTranslation) => {
        const updatedLookup = { ...state.selectedLookup };  

        if (!updatedLookup.translations) {
            updatedLookup.translations = { values: [] };
        }
        if (!updatedLookup.translations.values) {
            updatedLookup.translations.values = [];
        }

        if (updatedLookup.translations.values[itemIndex]) {
            if (!updatedLookup.translations.values[itemIndex].translations) {
                updatedLookup.translations.values[itemIndex].translations = {};
            }
            updatedLookup.translations.values[itemIndex].translations[state.selectedLookupValueLanguage] = newTranslation;
        }

        props.saveGlobalLookupsAction(updatedLookup, props.tenant.id);
        setState(prevState => ({
            ...prevState,
            selectedLookup: updatedLookup,
            selectedTranslationItem: null,
            selectedTranslationIndex: null
        }));
    };

    const translationLookupValuesEdit = () => {
        if (!state.isEditLookupValueTranslationOpen) {
            return null;
        }
        const currentTranslation = state.selectedTranslationItem?.translations[state.selectedLookupValueLanguage] || 
                                state.selectedTranslationItem?.original || '';

        return (
            <FuseInputModal
                label={`Translation for "${state.selectedTranslationItem?.original}"`}
                initialValue={currentTranslation}
                onOk={(valueChanged, returnValue) => {
                    setState(prevState => ({ ...prevState, isEditLookupValueTranslationOpen: false }));   
                    if (valueChanged) {
                        updateTranslation(state.selectedTranslationIndex, returnValue);
                    }
                }}
                onCancel={() => {
                    setState(prevState => ({
                        ...prevState,
                        isEditLookupValueTranslationOpen: false,
                        selectedTranslationItem: null,
                        selectedTranslationIndex: null
                    }));
                }}
            />
        );
    };

    const valueEdit = () => {
        if (state.isEditValueOpen === true) {
            return (
                <FuseInputModal
                    label='Value:'
                    initialValue={state.selectedValue.value}
                    onOk={(valueChanged, returnValue) => {
                        setState((state) => ({ ...state, isEditValueOpen: false }));
                        if (valueChanged === true) {

                            var toCommit = state.selectedValue.id == 'new' ? _.omit({ ...state.selectedValue }, ['id']) : state.selectedValue
                            toCommit.value = returnValue;
                            var newState = [...state.lookupValues];
                            if (toCommit.id === undefined) { //We've created a new item
                                newState.push(toCommit)
                                setState((state) => ({ ...state, newlookupValues: newState }));
                                updateValuesToLookup(newState)
                            }
                            else {
                                newState[toCommit.id] = toCommit;
                                setState((state) => ({ ...state, newlookupValues: newState }));
                                updateValuesToLookup(newState)
                            }
                        }
                    }
                    }
                    onCancel={() => {
                        setState((state) => ({ ...state, isEditValueOpen: false }));
                    }}
                />
            )
        }
        else {
            return;
        }
    }

    const isRootTenant = props.tenant.isRoot === true || false;

    const buildLookupValuePanes = () => {
        let  panes = [
        {   menuItem:'Lookup Values',
            render: ()=>
            <TabPane>
                {lookupValuesRender()}
            </TabPane>
        }
    ]

    const hasTranslations = (!_.isEmpty(state.selectedLookup?.translations?.values)&&(state.selectedLookup.status==='translation_successful'));
    if (hasTranslations) {
        const translationPanes = [
        {
        menuItem: 'Lookup Name Translations',
        render: () => (
            <TabPane>
                {state.selectedLookup?.name ? (
                        <>
                            <Header as="h4">
                            Lookup Name Translation for: &nbsp;&nbsp;"{state.selectedLookup.name}"
                            </Header>

                            <Table compact>
                            <Table.Header>
                                <Table.Row>
                                <Table.HeaderCell className='nectaPrimaryBg'>Language</Table.HeaderCell>
                                <Table.HeaderCell className='nectaPrimaryBg'>Translation</Table.HeaderCell>
                                <Table.HeaderCell className='nectaPrimaryBg' width={1}>Actions</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {availableLanguages.map(lang => {
                                const translation =
                                    state.selectedLookup.translations?.name?.[lang.value] || '';
                                return (
                                    <Table.Row key={lang.value}>
                                    <Table.Cell>{lang.text}</Table.Cell>
                                    <Table.Cell>
                                        {translation || <em style={{ color: '#999' }}>No translation</em>}
                                    </Table.Cell>
                                    <Table.Cell textAlign="right">
                                        <Button
                                        className='warning'
                                        compact
                                        icon="edit"
                                        size="mini"
                                        onClick={() => openLookupNameTranslationEdit(lang.value)}
                                        />
                                    </Table.Cell>
                                    </Table.Row>
                                );
                                })}
                            </Table.Body>
                            </Table>
                        </>
                        ) : (
                        <div style={{ padding: '1em' }}>No lookup selected.</div>
                        )}
            </TabPane>
            )
        }
        ,{
        menuItem: 'Lookup Value Translations',
        render: () => (
            <TabPane>
                <Dropdown
                    placeholder='Please select a language'
                    fluid
                    selection
                    options={availableLanguages}
                    onChange={handleLookupValueLanguageChange}
                    value={state.selectedLookupValueLanguage}
                />
                <Table compact selectable size='small'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell className='nectaPrimaryBg'>Original</Table.HeaderCell>
                            <Table.HeaderCell className='nectaPrimaryBg'>Translation</Table.HeaderCell>
                            <Table.HeaderCell className='nectaPrimaryBg' collapsing />
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {renderLookupValuesTranslaitons()}
                    </Table.Body>
                </Table>
            </TabPane>
            )
        }
    ]
    panes.push(...translationPanes);
    }
        return panes;
    }

    const lookupValuesModalRender = () => {
        return(
        <Modal 
        size='small'
        open={state.openLookupValuesModal}
        onClose={() => setState(prevState=>({
        ...prevState,
        openLookupValuesModal: false
        }))}
        >
        <Modal.Content scrolling>
          <Tab panes={buildLookupValuePanes()}/>
        </Modal.Content>
        <Modal.Actions>
          <Button color='red' onClick={() => setState(prevState =>({
            ...prevState,
            openLookupValuesModal: false
          }))}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
        );
    }





    const lookupValuesRender = () => {
        const isLoading = props.fetchingData;
        if (_.isEmpty(state.selectedLookup) || (state.selectedLookup.id < 1)) {
            return;
        }
        else {
            return (
                <div>
                    {(isLoading) &&
                    (<Dimmer active inverted>
                        <Loader>Loading...</Loader>
                    </Dimmer>)}
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width='8'>
                                <h3>{`${state.selectedLookup.name} Values:`}</h3>
                            </Grid.Column>
                            <Grid.Column width='8' textAlign='right'>
                                {(state.selectedLookup.status !=='translating')&&(<Button compact size ='small' color='blue'
                                    onClick={(e)=>{e.stopPropagation();
                                         setState((prevState)=>({
                                             ...prevState,
                                             showConfirmTranslate:true,
                                             translationMode: TRANSLATION_MODES.ADDITIVE
                                         }))}}>Translate</Button>
                                )}
                                {(state.selectedLookup.status ==='translating')&&(
                                <Label compact size='large' color='yellow'>
                                Translation in Progress
                                </Label>)}
                                
                                {(canCreateLookup() || ((isRootTenant))) && (state.selectedLookup !=='translating') && (
                                    <Button compact size='small' icon='add' className='success' floated='right' onClick={(e) => { e.stopPropagation(); onEditValueRow('new') }} />
                                )}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    
                {(!state.lookupValues || state.lookupValues.length === 0) ? (
                        <PlaceholderSegment text="There are no lookup values yet." />
                    ) : (

                    <Table compact selectable size='small'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='nectaPrimaryBg'>Value</Table.HeaderCell>
                                <Table.HeaderCell className='nectaPrimaryBg'></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {lookupValues()}
                        </Table.Body>
                    </Table>
                    )}
                </div>
            );
        }
    }
    // const isTranslating = props.lookups.some(item => item.status === "translating");
    return (
        <Container fluid>
            {confirmDelete()}
            {confirmEditLookUpValue()}
            <Grid>
                <Grid.Row>
                    <Grid.Column width='8'>
                        <h3>Lookups</h3>
                    </Grid.Column>
                    <Grid.Column width='8' textAlign='right'>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
                    {(canReadLookup() || isRootTenant) && (
                        <Input
                            icon='search'
                            placeholder='Search…'
                            value={state.lookupSearchQuery}
                            onChange={(e, { value }) =>
                            setState(prev => ({ ...prev, lookupSearchQuery: value }))
                            }
                            style={{ width: 264 }}
                        />
                    )}
                        {(canCreateLookup() || isRootTenant) &&(
                            <Button
                            compact
                            size='small'
                            icon='add'
                            className='success'
                            onClick={e => {
                                e.stopPropagation();
                                onEditLookupRow('new');
                            }}
                            />
                        )}
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            {lookupEdit()}
            {LookupItems()}
            {valueEdit()}
            {lookupValuesModalRender()}
            {translationLookupValuesEdit()}
            {lookupNameTranslationEdit()}
            {confirmTranslate()}
        </Container>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        userPermissions: _.isEmpty(state.authUserRoles.permissions) ? {} : state.authUserRoles.permissions,
        isPermissionsFetched: state.isPermissionsFetched === true,
        fetchingData: state.fetchingData === true,
        lookups: _.isEmpty(state.globalLookups) ? [] : Object.values(state.globalLookups),
        tenant: state.tenantManagement.activeTenant,
    };
}

export default connect(
    // map state to props
    mapStateToProps,
    // map dispatch to props
    (dispatch, ownProps) => ({
        fetchGlobalLookupsAction: (tenantId) => dispatch(GLOBAL_LOOKUP_ACTIONS.fetchGlobalLookupsAction(tenantId)),
        saveGlobalLookupsAction: (lookup, tenantId) => dispatch(GLOBAL_LOOKUP_ACTIONS.globalLookupSaveAction(lookup, tenantId)),
        deleteGlobalLookup: (lookup) => dispatch(GLOBAL_LOOKUP_ACTIONS.globalLookupDeleteAction(lookup)),
        translateLookup: (lookup, tenantId, translationMode) => dispatch(GLOBAL_LOOKUP_ACTIONS.translateLookupAction(lookup, tenantId, translationMode))
    })
)(GlobalLookupsPage);
